import React from 'react'

import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { YesNo } from 'components/_base'

type CustomerSubAccountProps = {
  is_sub_account?: boolean
  master_account?: { id: number; name: string } | null
}

const CustomerSubAccount = ({ is_sub_account, master_account }: CustomerSubAccountProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
    <YesNo value={is_sub_account} />

    {master_account && (
      <Box component="span" sx={{ fontSize: 12, fontStyle: 'italic' }}>
        under <Link to={UrlProvider.getUrl('customer', { id: master_account.id, tab: '' })}>{master_account.name}</Link>
      </Box>
    )}
  </Box>
)

export default CustomerSubAccount
